import { render, staticRenderFns } from "./OfferingInventory.vue?vue&type=template&id=4adea9e2"
import script from "./OfferingInventory.vue?vue&type=script&lang=js"
export * from "./OfferingInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports